import React, { useState, useEffect } from 'react'
import { Input, FormGroup, Label, Button } from 'reactstrap'
import { phoneValid } from '../../utils'
import { getRoles } from '../../redux/actions/indexActions'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { toast } from "react-toastify"
const CreateAdmin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { AuthReducer: { auth }, indexReducer: { roles } } = useSelector(state => state)
    const [errors, setErrors] = useState({})
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        role_id: "",
        password: "",
        confirmPassword: "",
        status: 1
    })

    const inputHandler = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
    }

    const handleSubmit = () => {
        const form = new FormData();
        form.append('name', formData.name);
        form.append('mobile', formData.mobile);
        form.append('email', formData.email);
        form.append('role_id', formData.role_id);
        form.append('password', formData.password);
        form.append('confirmPassword', formData.confirmPassword);
        form.append('status', formData.status);
        axios
            .post(`/api/admin/v1/admin-user/create`, form, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${auth?.token}`,
                },
            })
            .then((res) => {
                toast.success(res.data?.message);
                navigate(-1);
            })
            .catch((err) => {
                toast.error(err.response.data);
                setErrors(err.response.data);
            });
    };

    useEffect(() => {
        dispatch(getRoles(auth?.token))
    }, [auth])

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <h4 className="text-start text-white">Create Admin User</h4>
                </div>
            </div>
            <div className='bg-white px-3 py-3 rounded-2 my-4' >
                <div className="row">
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label> Name <span className="text-danger fs-4">*</span></Label>
                            <Input value={formData.name} invalid={Boolean(errors?.name)} onChange={inputHandler} name="name" />
                            <p className='text-danger' >
                                {errors?.name}
                            </p>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label> Email <span className="text-danger fs-4">*</span></Label>
                            <Input value={formData.email} invalid={Boolean(errors?.email)} onChange={inputHandler} name="email" />
                            <p className='text-danger' >
                                {errors?.email}
                            </p>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Mobile <span className="text-danger fs-4">*</span></Label>
                            <Input value={formData.mobile} invalid={Boolean(errors?.mobile)} onChange={(e) => phoneValid(e.target.value) && inputHandler(e)} name="mobile" />
                            <p className='text-danger' >
                                {errors?.mobile}
                            </p>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Role <span className="text-danger fs-4">*</span></Label>
                            <Input type='select' invalid={Boolean(errors?.role_id)} value={formData.role_id} onChange={inputHandler} name="role_id" >
                                <option value="">Select Role</option>
                                {roles?.map?.((item) => {
                                    return <option value={item?.id} key={item.id} >{item?.name}</option>
                                })}
                            </Input>
                            <p className='text-danger' >
                                {errors?.role_id}
                            </p>
                        </FormGroup>
                    </div>

                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Password <span className="text-danger fs-4">*</span></Label>
                            <Input type='password' invalid={Boolean(errors?.password)} value={formData.password} onChange={inputHandler} name="password" />
                            <p className='text-danger' >
                                {errors?.password}
                            </p>
                        </FormGroup>
                    </div>

                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Confirm Password <span className="text-danger fs-4">*</span></Label>
                            <Input type='password' invalid={Boolean(errors?.confirmPassword)} value={formData.confirmPassword} onChange={inputHandler} name="confirmPassword" />
                            <p className='text-danger' >
                                {errors?.confirmPassword}
                            </p>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup switch>
                            <Input
                                type="switch"
                                checked={formData?.status}
                                onChange={inputHandler}
                                name="status"
                            />
                            <Label check>Status</Label>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-4">
                        <Button color='primary' onClick={handleSubmit}>
                            Submit
                        </Button>
                        <Button className='ms-3' onClick={() => navigate(-1)} >
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateAdmin